<form [formGroup]="form" (ngSubmit)="submit()">
    <app-picklist [formControl]="form.controls['partNumbers']"
                  [source]="availableParts"
                  [target]="selectedPartNumbers"
                  displayField="nameWithSAP"
                  sourceHeader="{{'admin.tools.create-modal.pick-list.partNumbers.leftHeader' | translate}}"
                  targetHeader="{{'admin.tools.create-modal.pick-list.partNumbers.rightHeader' | translate}}">
    </app-picklist>
</form>
